require('./cardActivationR42Success.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ utilities
const { PROC_ACTIVATE_CARD } = require('utilities/tagging');

// @ constants
const { FIRST_STEP } = require('constants/index');
const {
    R42_CARD_OFF,
    R42_CARD_ON,
    R42_CARD_VIP,
} = require('constants/cardR42States');

class CardActivationR42Success extends React.Component {
    componentDidMount() {
        const {
            hireTravelPlusCCWrapUpOnFailure,
            hireTravelPlusCCWrapUpOnStart,
            hireTravelPlusCCWrapUpOnSuccess,
            immCardActivationR42,
            immTravelPlus,
        } = this.props;

        if (__CONTACT_CENTER__) {
            const isTravelPlusManuallyActivated = immCardActivationR42.getIn(['steps', FIRST_STEP, 'hireTravelPlus']);

            if (immCardActivationR42.get('travelPlusState') === R42_CARD_OFF && isTravelPlusManuallyActivated) {
                //These actions are only for Contact Center wrap up purpose
                hireTravelPlusCCWrapUpOnStart();

                if (immTravelPlus.get('submitSuccessful')) {
                    hireTravelPlusCCWrapUpOnSuccess();
                } else {
                    hireTravelPlusCCWrapUpOnFailure();
                }
            }
        }
    }

    buildSuccessMessage() {
        const {
            immCardActivationR42,
            immTravelPlus,
        } = this.props;
        const travelPlusInitialState = immCardActivationR42.get('travelPlusState');
        const isTravelPlusManuallyActivated = immCardActivationR42.getIn(['steps', FIRST_STEP, 'hireTravelPlus']);
        const travelPlusHiringSuccess = immTravelPlus.get('submitSuccessful');

        let messageType = 'informative';
        let messageText;
        let message;

        if (travelPlusInitialState === R42_CARD_VIP) {
            messageText = (
                <React.Fragment>
                    <FormattedText value="cardActivationR42-cardActivationR42_successService" />
                    <span className="card-activation-r42-success__bold">
                        <FormattedText value="cardActivationR42-cardActivationR42_successVipState" />
                    </span>
                </React.Fragment>
            );
        } else if (travelPlusInitialState === R42_CARD_OFF && isTravelPlusManuallyActivated) {
            if (travelPlusHiringSuccess) {
                messageText = (
                    <React.Fragment>
                        <FormattedText value="cardActivationR42-cardActivationR42_successService" />
                        <span className="card-activation-r42-success__bold">
                            <FormattedText value="cardActivationR42-cardActivationR42_successOffToOnState" />
                        </span>
                    </React.Fragment>
                );
            } else {
                messageText = <FormattedText value="cardActivationR42-cardActivationR42_successOffToOnErrorState" />;
                messageType = 'important';
            }
        } else if (travelPlusInitialState === R42_CARD_OFF && !isTravelPlusManuallyActivated) {
            messageText = (
                <React.Fragment>
                    <FormattedText value="cardActivationR42-cardActivationR42_successYouCan" />
                    <span className="card-activation-r42-success__bold">
                        <FormattedText value="cardActivationR42-cardActivationR42_successOffState" />
                    </span>
                </React.Fragment>
            );
        }

        if (travelPlusInitialState !== R42_CARD_ON) {
            message = (
                <div className="card-activation-r42-success__message-container">
                    <OKMessage
                        type={messageType}
                    >
                        {messageText}
                    </OKMessage>
                </div>
            );
        }

        return message;
    } 

    render() {
        const { immCard } = this.props;
        const title = formatText('cardActivate-successMessage');
        const goBackButtonLabel = formatText('cardActivate-goToCardDetails').toUpperCase();
        const linkToMovements = '/myprofile/cards';
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToMovements,
        };
        const successMessage = this.buildSuccessMessage();

        return (
            <article className="col-xs-10 col-xs-offset-1">
                <WizardSuccess
                    mainButton={goBackButton}
                    processType={PROC_ACTIVATE_CARD}
                    successMessage={title}
                >
                    <section className="row no-gutter">
                        <div className="col-xs-5">
                            <CommercialAds
                                immCard={immCard}
                                path="cards"
                                size="medium"
                                type="cards"
                            />
                        </div>
                    </section>
                    {successMessage}
                </WizardSuccess>
            </article>
        );
    }
}

CardActivationR42Success.propTypes = {
    hireTravelPlusCCWrapUpOnFailure: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnStart: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnSuccess: PropTypes.func.isRequired,
    immCard: PropTypes.object.isRequired,
    immCardActivationR42: PropTypes.object.isRequired,
    immTravelPlus: PropTypes.object.isRequired,
};

module.exports = CardActivationR42Success;
